<template>
  <div>
    <b-overlay :show="show">
      <b-row>
        <b-col>
          <div class="alert-success alert">{{ $t("getinfobyGnk") }}</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-list-group>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
            >
              <span> {{ $t("name") }}: </span>
              <span style="font-weight:bolder"> {{ GNKInfo.name }} </span>
            </b-list-group-item>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
            >
              <span> {{ $t("inn") }}: </span>
              <span style="font-weight:bolder"> {{ GNKInfo.tin }} </span>
            </b-list-group-item>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
              ><span> {{ $t("address") }}: </span>
              <span style="font-weight:bolder">
                {{ GNKInfo.address }}
              </span></b-list-group-item
            >
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
              ><span> {{ $t("mfo") }}: </span>
              <span style="font-weight:bolder">
                {{ GNKInfo.mfo }}
              </span></b-list-group-item
            >

            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
            >
              <span> {{ $t("account") }}: </span>
              <span style="font-weight:bolder"> {{ GNKInfo.account }} </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col>
          <b-list-group>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
            >
              <span> {{ $t("director") }}: </span>
              <span style="font-weight:bolder">
                {{ GNKInfo.director }} ({{ GNKInfo.directorTin }})
              </span>
            </b-list-group-item>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
              ><span> {{ $t("accountant") }}: </span>
              <span style="font-weight:bolder">
                {{ GNKInfo.accountant }}
              </span></b-list-group-item
            >

            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
              ><span> {{ $t("oked") }}: </span>
              <span style="font-weight:bolder">
                {{ GNKInfo.oked }}
              </span></b-list-group-item
            >
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
              ><span> {{ $t("status") }}: </span>
              <span style="font-weight:bolder">
                {{ GNKInfo.statusName }}
              </span></b-list-group-item
            >
          </b-list-group>
        </b-col>
      </b-row>
      <b-tabs pills class="mt-3">
        <b-tab :title="$t('category')">
          <b-row class="mt-3">
            <b-col>
              <b-table
                head-row-variant="info"
                :fields="fields1"
                :items="data.UzexListByProductCategory"
                bordered
                small
                sticky-header="60vh"
                no-border-collapse
              >
                <template #cell(totalcost)="{item}">
                  {{
                    $options.filters.currency(item.totalcost, {
                      symbol: "",
                      fractionCount: 0
                    })
                  }}
                </template>
                <template v-slot:custom-foot>
                  <b-tr>
                    <b-td variant="info" class="text-center"
                      ><b> {{ $t("Total") }} : </b>
                    </b-td>
                    <b-td variant="info" class="text-right"
                      ><span style="white-space:nowrap;font-weight:bolder">
                        {{
                          $options.filters.currency(total.quantityCat, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span></b-td
                    >
                    <b-td variant="info" class="text-right"
                      ><span style="white-space:nowrap;font-weight:bolder">
                        {{
                          $options.filters.currency(total.sumCat, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span>
                    </b-td>
                  </b-tr>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('lotbyorg')">
          <b-row class="mt-3">
            <b-col>
              <b-table
                head-row-variant="info"
                :fields="fields2"
                :items="data.UzexListByAddress"
                bordered
                sticky-header="60vh"
                small
                no-border-collapse
              >
                <template #cell(totalcost)="{item}">
                  <span style="white-space:nowrap">
                    {{
                      $options.filters.currency(item.totalcost, {
                        symbol: "",
                        fractionCount: 0
                      })
                    }}
                  </span>
                </template>
                <template #cell(sharepercent)="{item}">
                  <span style="white-space:nowrap">
                    {{ item.sharepercent }} %
                  </span>
                </template>
                <template #cell(buyer_name)="{item}">
                  <a
                    href="javascript:void(0)"
                    @click="
                      $router.push({
                        name: 'BuyerCard',
                        query: { buyerid: 0, buyertin: item.buyer_tin }
                      })
                    "
                  >
                    {{ item.buyer_name }}
                  </a>
                </template>
                <template v-slot:custom-foot>
                  <b-tr>
                    <b-td variant="info" class="text-center" colspan="2"
                      ><b> {{ $t("Total") }} : </b>
                    </b-td>
                    <b-td variant="info" class="text-right"
                      ><span style="white-space:nowrap;font-weight:bolder">
                        {{
                          $options.filters.currency(total.quantityAddress, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span></b-td
                    >
                    <b-td variant="info" class="text-right"
                      ><span style="white-space:nowrap;font-weight:bolder">
                        {{
                          $options.filters.currency(total.sumAddress, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span>
                    </b-td>
                  </b-tr>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('lotinfo')">
          <b-row class="mt-3">
            <b-col>
              <b-table
                head-row-variant="info"
                :fields="fields3"
                :items="data.UzexListByLotInfo"
                bordered
                sticky-header="60vh"
                small
                no-border-collapse
              >
                <template #cell(totalcost)="{item}">
                  <span style="white-space:nowrap">{{
                    $options.filters.currency(item.totalcost, {
                      symbol: "",
                      fractionCount: 0
                    })
                  }}</span>
                </template>
                <template #cell(actions)="{item}">
                  <b-link
                    id="show-btn"
                    class="text-center d-flex justify-content-center"
                    @click="showModal(item)"
                    v-b-tooltip.hover.top="$t('View')"
                  >
                    <i class="mdi mdi-eye"></i>
                  </b-link>
                  <b-modal :id="'my-modal' + item.id" size="xl" hide-footer>
                    <div class="row m-2">
                      <b-row>
                        <b-col md="6" sm="12"
                          ><h4>{{ $t("lotid") }} : {{ item.lotid }}</h4></b-col
                        >
                        <b-col md="6" sm="12"
                          ><h4>
                            {{ $t("oblast") }} : {{ item.oblastname }}
                          </h4></b-col
                        >
                        <b-col md="6" sm="12"
                          ><h4>
                            {{ $t("region") }} : {{ item.regionname }}
                          </h4></b-col
                        >
                        <b-col md="6" sm="12"
                          ><h4>
                            {{ $t("buyername") }} : {{ item.buyername }}
                          </h4></b-col
                        >
                        <b-col md="6" sm="12"
                          ><h4>
                            {{ $t("category") }} : {{ item.categoryname }}
                          </h4></b-col
                        >
                        <b-col md="6" sm="12"
                          ><h4>
                            {{ $t("product") }} : {{ item.productname }}
                          </h4></b-col
                        >
                      </b-row>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <b-table
                          :fields="fieldsModal"
                          bordered
                          :items="items1"
                          style="min-height: 100px"
                          responsive="sm"
                          :busy="isLoading"
                          head-row-variant="info"
                          sticky-header="60vh"
                          no-border-collapse
                          no-footer-sorting
                          striped
                          show-empty
                        >
                          <template v-slot:empty>
                            <h5 class="text-center">{{ $t("NoItems") }}</h5>
                          </template>
                          <template #cell(price)="{ item }">
                            {{
                              $options.filters.currency(item.price, {
                                symbol: "  ",
                                fractionCount: 2
                              })
                            }}
                          </template>
                          <template #cell(status_name)="{ item }">
                            <span
                              :class="
                                `badge rounded-pill bg-${$getItemColor(
                                  item
                                )} ms-1`
                              "
                            >
                              {{
                                item.status_name == "Winner"
                                  ? "Победитель"
                                  : "Отменено"
                              }}
                            </span>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </b-modal>
                </template>
                <template #cell(amount)="{item}">
                  <span style="white-space:nowrap">
                    {{
                      $options.filters.currency(item.amount, {
                        symbol: "",
                        fractionCount: 0
                      })
                    }}
                  </span>
                </template>
                <template #cell(price)="{item}">
                  <span style="white-space:nowrap">
                    {{
                      $options.filters.currency(item.price, {
                        symbol: "",
                        fractionCount: 0
                      })
                    }}
                  </span>
                </template>
                <template v-slot:custom-foot>
                  <b-tr>
                    <b-td variant="info" class="text-center" colspan="7"
                      ><b> {{ $t("Total") }} : </b>
                    </b-td>
                    <b-td variant="info"
                      ><span style="white-space:nowrap;font-weight:bolder">
                        {{
                          $options.filters.currency(total.quantityLot, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span></b-td
                    >
                    <b-td variant="info"></b-td>
                    <b-td variant="info"
                      ><span style="white-space:nowrap;font-weight:bolder">
                        {{
                          $options.filters.currency(total.sumLot, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span>
                    </b-td>
                  </b-tr>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('product')">
          <b-row class="mt-3">
            <b-col>
              <b-table
                head-row-variant="info"
                :fields="fields4"
                :items="data.UzexListByProduct"
                bordered
                sticky-header="60vh"
                small
                no-border-collapse
              >
                <template #cell(minprice)="{item}">
                  <span style="white-space:nowrap;text-align:right">
                    {{
                      $options.filters.currency(item.minprice, {
                        symbol: "",
                        fractionCount: 0
                      })
                    }}
                  </span>
                </template>
                <template #cell(maxprice)="{item}">
                  <span style="white-space:nowrap;text-align:right">
                    {{
                      $options.filters.currency(item.maxprice, {
                        symbol: "",
                        fractionCount: 0
                      })
                    }}
                  </span>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-overlay>
  </div>
</template>

<script>
import UzexService from "@/services/others/uzex.service";
import ReportService from "@/services/reports/report.service";
export default {
  props: {
    providerid: {},
    providertin: {}
  },
  data() {
    return {
      fields1: [
        { key: "category_name", label: this.$t("category") },
        { key: "totalcount", label: this.$t("lotcount"), class: "text-right" },
        { key: "totalcost", label: this.$t("totalcost"), class: "text-right" }
      ],
      fields2: [
        { key: "buyer_region", label: this.$t("oblast") },
        { key: "buyer_name", label: this.$t("buyername") },
        { key: "lotcount", label: this.$t("lotcount"), class: "text-right" },
        {
          key: "sharepercent",
          label: this.$t("sharepercent"),
          class: "text-right"
        },
        { key: "totalcost", label: this.$t("totalcost"), class: "text-right" }
      ],
      fields3: [
        // { key : 'actions',label : this.$t('actions') },
        { key: "lotid", label: this.$t("lotid") },
        { key: "lotdate", label: this.$t("lotdate") },
        { key: "oblastname", label: this.$t("oblast") },
        { key: "regionname", label: this.$t("region") },
        { key: "buyername", label: this.$t("buyername") },
        { key: "categoryname", label: this.$t("category") },
        { key: "productname", label: this.$t("product") },
        { key: "amount", label: this.$t("amount"), class: "text-right" },
        { key: "price", label: this.$t("price"), class: "text-right" },
        { key: "totalcost", label: this.$t("totalcost"), class: "text-right" }
      ],
      fields4: [
        { key: "product_name", label: this.$t("product") },
        {
          key: "minprice",
          label: this.$t("minprice"),
          class: "text-right",
          class: "text-right"
        },
        { key: "maxprice", label: this.$t("maxprice"), class: "text-right" }
      ],
      data: {},
      show: false,
      GNKInfo: {},
      total: {
        sumLot: 0,
        quantityLot: 0,
        quantityAddress: 0,
        sumAddress: 0,
        quantityCat: 0,
        sumCat: 0
      },
      items1: [],
      fieldsModal: [
        {
          key: "tin",
          label: this.$t("tin"),
          sort: true,
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: { width: "10% !important" }
        },
        {
          key: "org",
          label: this.$t("provider"),
          sort: true,
          tdClass: "text-left",
          thClass: "text-center",
          thStyle: { width: "5% !important" }
        },
        {
          key: "biddate",
          label: this.$t("biddate"),
          sort: true,
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: { width: "5% !important" }
        },
        {
          key: "price",
          label: this.$t("price"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" }
        },
        {
          key: "status_name",
          label: this.$t("status"),
          sort: true,
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: { width: "5% !important" }
        }
      ],
      isLoading: false
    };
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      this.show = true;
      UzexService.ProviderCard(this.providerid, this.providertin)
        .then(res => {
          this.data = res.data.result;
          this.GNKInfo = res.data.result.GNKInfo;
          this.show = false;
          this.calculateTotal();
        })
        .catch(error => {
          this.$notification(error.response.data.error, "danger");
          this.show = false;
        });
    },
    showModal(item) {
      this.$bvModal.show("my-modal" + item.id);
      this.isLoading = true;
      ReportService.GetAuctionLotInfoStakan(item.lotid)
        .then(res => {
          this.items1 = res.data.result;
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    calculateTotal() {
      var self = this;
      self.total = {
        sumLot: 0,
        quantityLot: 0,
        quantityAddress: 0,
        sumAddress: 0,
        quantityCat: 0,
        sumCat: 0
      };
      self.data.UzexListByLotInfo.forEach(function(item) {
        self.total.sumLot += item.totalcost;
        self.total.quantityLot += item.amount;
      });
      self.data.UzexListByAddress.forEach(function(item) {
        self.total.sumAddress += item.totalcost;
        self.total.quantityAddress += item.lotcount;
      });
      self.data.UzexListByProductCategory.forEach(function(item) {
        self.total.sumCat += item.totalcost;
        self.total.quantityCat += item.totalcount;
      });
    }
  }
};
</script>

<style></style>
